// extracted by mini-css-extract-plugin
module.exports = {"picture":"picture--mvYk0","initialized":"initialized--ES+y4"};